import React, { useEffect, useState } from "react";
import { apiWrap, apiWrapWithErrorWithData } from "../utilities/apiHelpers";
import { addBuApi, getAllBuList, updateBuApi } from "../utilities/apis/users";
import {
  ActionIcon,
  Button,
  Card,
  Group,
  Modal,
  Select,
  Stack,
  Switch,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import { IconArrowLeft, IconEdit, IconPlus } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import AppHeader from "../components/Header/AppHeader";
import { showNotification } from "@mantine/notifications";

const BuList = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    addBu: "",
    editBu: "",
  });

  const [configs, setConfigs] = useState({
    loading: true,
    buData: [],
  });
  const [updateConfigs, setUpdateConfigs] = useState({
    buData: null,
    editBu: false,
  });
  const [uiConfigs, setUiConfigs] = useState({
    loading: false,
    refresh: true,
  });
  const [addBuData, setAddBuData] = useState({
    businessunitName: "",
    orgId: 1,
  });
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const bulist = async () => {
      const response = await apiWrapWithErrorWithData(getAllBuList());
      console.log("response: ", response);
      if (response.success) {
        setConfigs({
          loading: false,
          buData: response.result,
        });
      }
    };
    bulist();
  }, [uiConfigs.refresh]);
  const addBusinessUnit = async () => {
    const response = await apiWrapWithErrorWithData(
      addBuApi({ buData: addBuData }),
    );
    if (response.success) {
      showNotification({
        title: "add business unit",
        message: "bussiness unit added",
        color: "green",
      });
      setShowModal(false);

      setAddBuData({
        businessunitName: "",
        orgId: 1,
      });

      setUiConfigs((prev) => ({
        ...prev,
        refresh: !prev.refresh,
      }));
      setUiConfigs({
        loading: false,
        refresh: !uiConfigs.refresh,
      });
    }
  };

  const updateBusinessUnit = async () => {
    const response = await apiWrapWithErrorWithData(
      updateBuApi({ buData: updateConfigs.buData }),
    );
    if (response.success) {
      showNotification({
        title: "update business unit ",
        color: "green",
        message: "business unit updated",
      });
      setUpdateConfigs({
        buData: null,
        editBu: false,
      });

      setUiConfigs((prev) => ({
        ...prev,
        refresh: !prev.refresh,
      }));
    } else {
      showNotification({
        title: "update business unit ",
        color: "red",
        message: "business unit not updated",
      });
    }
  };
  console.log("update configs: ", updateConfigs);
  return (
    <div>
      <AppHeader hide={true} />
      <div className="m-8">
        <div className="dashboard-header">
          <div>
            <h1 className="dashboard-heading">Business Units</h1>
            <p className="dashboard-subtitle">
              Manage business units and their status
            </p>
          </div>
        </div>
        <div className="flex justify-end mb-8">
          <Group>
            <Button
              variant="light"
              leftSection={<IconArrowLeft size={16} />}
              onClick={() => navigate("/team-manager")}
            >
              <IconArrowLeft size={20} />
              <span style={{ marginLeft: "8px" }}>Back To Users</span>
            </Button>

            <Button
              leftSection={<IconPlus size={16} />}
              onClick={() => {
                setErrors({});
                setShowModal(true);
              }}
            >
              <IconPlus size={20} />
              <span style={{ marginLeft: "8px" }}>Add Business Unit</span>
            </Button>
          </Group>
        </div>
        <div>
          {!configs.loading && configs.buData.length > 0 && (
            <Card shadow="sm" radius="xl" p="lg" withBorder>
              <Table
                striped
                highlightOnHover
                verticalSpacing="md"
                horizontalSpacing="lg"
              >
                <thead>
                  <tr>
                    <th>id</th>
                    <th>name</th>
                    <th>enabled</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {configs.buData.map((bu) => (
                    <tr key={bu.id}>
                      <td>{bu.id}</td>
                      <td>{bu.name}</td>
                      <td>
                        <Text fw={700} color={bu.enabled ? "green" : "red"}>
                          {bu.enabled ? "Enabled" : "Disabled"}
                        </Text>
                      </td>
                      <td>
                        <ActionIcon
                          color="blue"
                          variant="light"
                          radius="xl"
                          size="lg"
                          onClick={() =>
                            setUpdateConfigs({
                              editBu: true,
                              buData: {
                                id: bu.id,
                                name: bu.name,
                                enabled: !!bu.enabled,
                              },
                            })
                          }
                        >
                          <IconEdit size={18} />
                        </ActionIcon>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          )}
        </div>
      </div>
      <Modal
        opened={showModal}
        onClose={() => {
          setShowModal(false);
          setErrors({});
        }}
        size="md"
        radius="xl"
        centered
        title={
          <Stack gap={2}>
            <Text fw={700} size="xl">
              Add Business Unit
            </Text>

            <Text size="xs" c="dimmed">
              Create a new business unit
            </Text>
          </Stack>
        }
      >
        <Stack>
          <TextInput
            label="Business Unit Name"
            placeholder="Enter business unit name"
            radius="md"
            value={addBuData.businessunitName}
            error={errors.addBu}
            onChange={(e) =>
              setAddBuData({
                ...addBuData,
                businessunitName: e.target.value,
              })
            }
          />

          <Group justify="right">
            <Button
              radius="md"
              loading={uiConfigs.loading}
              onClick={() => {
                if (!addBuData.businessunitName.trim()) {
                  setErrors({
                    addBu: "Please enter business unit name",
                  });
                  return;
                }

                setUiConfigs({
                  ...uiConfigs,
                  loading: true,
                });

                addBusinessUnit();
              }}
            >
              Add Business Unit
            </Button>
          </Group>
        </Stack>
      </Modal>

      <Modal
        opened={updateConfigs.editBu}
        onClose={() =>
          setUpdateConfigs({
            buData: null,
            editBu: false,
          })
        }
        size="md"
        radius="xl"
        centered
        title={
          <Stack gap={2}>
            <Text fw={700} size="xl">
              Update Business Unit
            </Text>

            <Text size="xs" c="dimmed">
              Update business unit details
            </Text>
          </Stack>
        }
      >
        <Stack>
          <TextInput
            radius="md"
            label="Business Unit Name"
            placeholder="Enter business unit name"
            value={updateConfigs.buData?.name || ""}
            error={errors.editBu}
            onChange={(e) =>
              setUpdateConfigs({
                ...updateConfigs,
                buData: {
                  ...updateConfigs.buData,
                  name: e.target.value,
                },
              })
            }
          />

          <Switch
            label="Enabled"
            checked={updateConfigs.buData?.enabled || false}
            onChange={(e) =>
              setUpdateConfigs({
                ...updateConfigs,
                buData: {
                  ...updateConfigs.buData,
                  enabled: e.currentTarget.checked,
                },
              })
            }
          />

          <Group justify="right">
            <Button
              radius="md"
              onClick={() => {
                if (!updateConfigs.buData?.name?.trim()) {
                  setErrors({
                    editBu: "Please enter business unit name",
                  });
                  return;
                }

                updateBusinessUnit();
              }}
            >
              Update Business Unit
            </Button>
          </Group>
        </Stack>
      </Modal>
    </div>
  );
};

export default BuList;
